import { DashboardType } from '@/api/auth/getMe.ts'

export interface IDashboardSummarySource {
    useCount: boolean
    useDeviceStatus: boolean
}

export const getDashboardSummarySource = (
    isMePending: boolean,
    dashboardType?: DashboardType
): IDashboardSummarySource => {
    if (isMePending) return { useCount: false, useDeviceStatus: false }

    const isCareManager = dashboardType === DashboardType.CARE_MANAGER
    return { useCount: !isCareManager, useDeviceStatus: isCareManager }
}
